export const defaultMenuList = [
  { name: 'Home', icon: 'map', key: '0', path: '/home' },
  { name: '지점 현황', icon: 'dashboard', key: '1', path: '/branch' },
  { name: 'CCTV . 뷰가드', icon: 'cam', key: '2', path: 'https://new.capslive.co.kr/' },
  { name: '알림 로그', icon: 'history', key: '3', path: '/notification' },
  { name: '관리자 설정', icon: 'admin', key: '4', path: '/branch/management' },
];
